import React from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import AutocompleteBase from './AutocompleteBase';
import AutoCompleteDropdownBase from './AutoCompleteDropdownBase';

class Autocomplete extends React.Component {
  static propTypes = {
    /** Floating label */
    label: PropTypes.string.isRequired,
    /** Callback function that fires when autocomplete adds/removes values */
    onChange: PropTypes.func.isRequired,
  };


  render() {
    if (this.props.dropdownstyle) {
      return <AutoCompleteDropdownBase {...this.props} />;
    }
    else
      return <AutocompleteBase {...this.props} />;
  }
}

export default Autocomplete;
